(function () {
    'use strict';

    // Calendario de órdenes de trabajo (tarjetas kanban por fecha de
    // planificación). Es una pestaña de /backend/shifts/showcalendar, pero con
    // su propio mes, independiente del calendario de turnos (ShiftsController).
    angular
        .module('appback')
        .controller('WorkOrdersCalendarController', WorkOrdersCalendarController);

    WorkOrdersCalendarController.$inject = ["WorkOrdersService", "$q"];

    function WorkOrdersCalendarController(WorkOrdersService, $q) {

        var vm = this;

        // Textos traducibles: la clave es el texto en inglés y la traducción
        // llega de showcalendar.twig (window.shiftsI18n, generado con t.getTraduction).
        // {nombre} se sustituye por params.nombre.
        function tr(text, params) {
            var dict = window.shiftsI18n || {};
            var result = dict[text] || text;
            angular.forEach(params || {}, function (value, key) {
                result = result.split('{' + key + '}').join(value);
            });
            return result;
        }

        vm.tr = tr;

        var now = new Date();

        vm.monthNames = [
            tr('January'), tr('February'), tr('March'), tr('April'), tr('May'), tr('June'),
            tr('July'), tr('August'), tr('September'), tr('October'), tr('November'), tr('December')
        ];

        vm.weekDays = [tr('Monday'), tr('Tuesday'), tr('Wednesday'), tr('Thursday'), tr('Friday'), tr('Saturday'), tr('Sunday')];

        vm.month = now.getMonth() + 1;
        vm.year = now.getFullYear();
        vm.daysInMonth = 0;

        vm.weeks = [];
        vm.byDay = {};
        vm.total = 0;
        vm.loading = false;
        vm.error = '';

        // Filtro por tablero: '' (todos) | id del tablero | 'none' (sin tablero).
        // Se filtra en el cliente sobre todas las OTs del mes (vm.allByDay).
        vm.boards = [];
        vm.boardFilter = '';
        vm.allByDay = {};

        // Filtro por personal: '' (todos) | id de la persona | 'none' (sin asignar).
        // La lista la manda el servidor (personal del departamento configurado
        // en workOrdersCalendarDepartmentSapId); la persona seleccionada se
        // mantiene en la lista aunque ya no venga.
        vm.people = [];
        vm.personFilter = '';
        vm.personFilterName = '';
        vm.personSearch = '';

        vm.buildPeople = function (people) {

            var list = (people || []).map(function (person) {
                return { id: String(person.id), name: person.name };
            });

            var selectedListed = list.some(function (person) {
                return person.id === vm.personFilter;
            });

            if (vm.personFilter && vm.personFilter !== 'none' && !selectedListed) {
                list.push({ id: vm.personFilter, name: vm.personFilterName });
            }

            vm.people = list;
        };

        vm.setPersonFilter = function (person) {

            vm.personFilter = person ? (person === 'none' ? 'none' : String(person.id)) : '';
            vm.personFilterName = person && person !== 'none' ? person.name : '';

            vm.applyBoardFilter();
        };

        vm.matchesPersonSearch = function (person) {

            var search = (vm.personSearch || '').toLowerCase().trim();

            return !search || String(person.name).toLowerCase().indexOf(search) !== -1;
        };

        vm.load = function () {

            vm.loading = true;
            vm.error = '';

            return WorkOrdersService.GetWorkOrders({
                month: vm.month,
                year: vm.year
            }).then(function (data) {

                if (!data || !data.success) {
                    return $q.reject(data);
                }

                vm.allByDay = data.days || {};
                vm.boards = data.boards || [];
                vm.daysInMonth = data.daysInMonth;

                vm.buildPeople(data.people);
                vm.applyBoardFilter();

                vm.weeks = vm.buildMonthWeeks(data.year, data.month, data.daysInMonth);

            }).catch(function (error) {

                var detail = error && error.data && error.data.message ? ' ' + error.data.message : '';

                vm.error = tr('Could not get the work orders calendar.') + detail;

            }).finally(function () {

                vm.loading = false;
            });
        };

        vm.changeMonth = function (delta) {

            var date = new Date(vm.year, vm.month - 1 + delta, 1);

            vm.month = date.getMonth() + 1;
            vm.year = date.getFullYear();

            vm.load();
        };

        // Aplica los filtros de tablero y de personal.
        vm.applyBoardFilter = function () {

            var filter = vm.boardFilter;
            var personFilter = vm.personFilter;

            vm.byDay = {};
            vm.total = 0;

            var matchesBoard = function (card) {

                if (!filter) {
                    return true;
                }

                if (filter === 'none') {
                    return !card.board;
                }

                return card.board && String(card.board.id) === String(filter);
            };

            var matchesPerson = function (card) {

                var people = card.assigned_people || [];

                if (!personFilter) {
                    return true;
                }

                if (personFilter === 'none') {
                    return !people.length;
                }

                return people.some(function (person) {
                    return String(person.id) === personFilter;
                });
            };

            angular.forEach(vm.allByDay, function (cards, day) {

                var filtered = cards.filter(function (card) {
                    return matchesBoard(card) && matchesPerson(card);
                });

                if (filtered.length) {
                    vm.byDay[day] = filtered;
                    vm.total += filtered.length;
                }
            });
        };

        // Semanas del mes (de lunes a domingo); los huecos antes del día 1 y
        // después del último día van a null.
        vm.buildMonthWeeks = function (year, month, daysInMonth) {

            // getDay(): 0 = domingo; se pasa a 0 = lunes.
            var offset = (new Date(year, month - 1, 1).getDay() + 6) % 7;
            var cells = [];
            var weeks = [];

            for (var i = 0; i < offset; i++) {
                cells.push(null);
            }

            for (var day = 1; day <= daysInMonth; day++) {
                cells.push(day);
            }

            while (cells.length % 7) {
                cells.push(null);
            }

            for (var j = 0; j < cells.length; j += 7) {
                weeks.push(cells.slice(j, j + 7));
            }

            return weeks;
        };

        // Casillas de alto fijo: con una sola OT se ve la tarjeta completa; con
        // más, solo la primera línea de cada una, hasta maxCompactCards, y el
        // resto se resume en "+N" (se ven todas en el popup del día).
        vm.maxCompactCards = 3;

        vm.isCompactDay = function (day) {
            return (vm.byDay[day] || []).length > 1;
        };

        vm.visibleCount = function (day) {
            return vm.isCompactDay(day) ? vm.maxCompactCards : 1;
        };

        vm.hiddenCount = function (day) {
            return Math.max(0, (vm.byDay[day] || []).length - vm.visibleCount(day));
        };

        // Popup con las OTs de un día (las de vm.byDay: con el filtro de tablero aplicado).
        vm.dayModal = {
            open: false,
            title: '',
            cards: []
        };

        vm.openDay = function (day) {

            // getDay(): 0 = domingo; se pasa a 0 = lunes, como vm.weekDays.
            var weekDay = vm.weekDays[(new Date(vm.year, vm.month - 1, day).getDay() + 6) % 7];

            vm.dayModal = {
                open: true,
                title: tr('{weekday}, {month} {day}, {year}', {
                    weekday: weekDay,
                    day: day,
                    month: vm.monthNames[vm.month - 1],
                    year: vm.year
                }),
                cards: vm.byDay[day] || []
            };
        };

        vm.closeDay = function () {
            vm.dayModal.open = false;
        };

        // Lleva al tablero de la OT y abre su tarjeta (el kanban la abre con ?card=id).
        // Las que no están en ningún tablero no llevan a ningún sitio.
        vm.goToCard = function (card) {

            if (!card || !card.board) {
                return;
            }

            window.location.href = '/backend/kanban/showcards?board=' + encodeURIComponent(card.board.id) +
                '&card=' + encodeURIComponent(card.id);
        };

        vm.isToday = function (day) {

            var today = new Date();

            return day === today.getDate() &&
                vm.month === (today.getMonth() + 1) &&
                vm.year === today.getFullYear();
        };

        // Texto de la recurrencia a partir de recurring_days.
        vm.formatRecurrence = function (days) {

            days = parseInt(days, 10) || 0;

            if (!days) {
                return tr('Recurring');
            }

            if (days === 1) {
                return tr('Every day');
            }

            if (days === 7) {
                return tr('Every week');
            }

            if (days % 7 === 0) {
                return tr('Every {count} weeks', { count: days / 7 });
            }

            return tr('Every {count} days', { count: days });
        };

        vm.load();
    }
})();
